export const navbarplugin = (editor, opts = {}) => {
  const labels = {
    block1: true,
  }

  const categories = {
    category1: 'Navbars',
  }

  opts = { labels: labels, categories: categories }
  loadComponents(editor, opts)
}

const loadComponents = (editor, options) => {
  const { categories } = options
  const blcks = editor.config.pluginsOpts.navbars
  blcks.map((blk, blkInd) => {
    editor.BlockManager.add('block' + blkInd, {
      label: blk.themeNavbarName,
      category: categories.category1,
      content: `${blk.themeNavbarHTML}`,
    })
  })
}
